import { render, staticRenderFns } from "./AutoVerificationDetails.vue?vue&type=template&id=63887d88&"
import script from "./AutoVerificationDetails.vue?vue&type=script&lang=js&"
export * from "./AutoVerificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports